<template>
    <div>
        <nav id="nav">
            <div class="navbar my-container">
                <div class="nav-logo">
                    <img width="50px" src="/nawrs-logo.svg" alt="Logo">
                </div>
                <div class="buttons">
                    <button class="btn btn1">
                        <router-link to="/login" class="">{{$t('login')}}</router-link>
                    </button>
                </div>
            </div>
        </nav>
        <section id="pages-header" class="my-container">
            <div class="title-pages title-terms-conditions">
                <h3>{{ $t('termsCondition') }}</h3>
                <h4>يرجي قراءة الشروط والأحكام لتأكيد ذلك</h4>
                <p v-html="terms_and_conditions.page.content"></p>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters('dataList', ['terms_and_conditions']),
    },
    methods: {
        ...mapActions('dataList', ['fetchTermsAndCondition']),
    },
    created(){
        this.fetchTermsAndCondition()
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

.title-page{
    margin-bottom: 1.3rem;
    margin-top: 1.3rem;
}
.line{
    border-bottom: 0.03125rem solid #70707061;
    opacity: 50%;
    margin-bottom: 1.3rem;
}
P{
    color: #212121;
    font-weight: 600;
    line-height: 2.5rem;
}
.my-container
{
    padding: 0px 170px !important;
    width: 100% !important;
    margin: auto;
}
#nav
{
    box-shadow: 0px 2px 8px #0000000A;
    background-color: #FFF;
    padding: 21px 0px;
    width: 100%;
}
.navbar
{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btn{
    color: $mainColor1;
    width: fit-content;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    border: none;
}
.btn1:hover{
    background-color: $mainColor1;
}
.btn1:hover a{
    color: #FFF;
}
.btn1{
    background-color: $mainColor2;
    transition: .3s;
    height: 38px;
}
.title-terms-conditions{
    margin-bottom: 64px;
}
.title-terms-conditions h4{
    font-size: 32px;
    line-height: 47px;
}
.title-pages p, .title-pages p p, .title-pages p p span{
    color: #212121 !important;
    font-size: 18px !important;
    line-height: 35px !important;
    font-weight: 600 !important;
    white-space: pre-line !important;
    background-color: transparent !important;
    font-family: 'Cairo' !important;
}
.title-terms-conditions p{
    font-size: 16px;
    text-align: left;
    line-height: 32px;
}
#pages-header{
    padding-top: 71px !important;
    margin-bottom: 32px;
}
.title-pages{
    background-color: $seconderyColorTermsConditions;
    border-radius: 4px;
    padding: 51px 35px 27px 35px;
    text-align: center;
    position: relative;
}
.title-pages h3{
    color: #FFF;
    font-size: 36px;
    font-weight: bold;
    line-height: 60px;
    position: absolute;
    padding: 5px 30px;
    top: -39px;
    left: 50%;
    transform: translateX(-50%);
}
.title-pages h3::before{
    content: '';
    background-color: $mainColorTermsConditions;
    transform: skew(-20deg);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
	left: 0;
    z-index: -1;
}
.title-pages h4{
    color: $mainColor1;
    font-size: 32px;
    line-height: 47px;
    margin-bottom: 8px;
    font-weight: bold;
}
</style>